import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'

import {mutations} from '../../../../api/mutations'
import {invalidateSettingsQuery} from '../../../common/providers'
import {ErrorResponse} from '../../../common/types'
import {notifyIfErrorMessage} from '../../../common/utils'
import {ProductionLine} from '../../types/departmentConfig'

export const useCreateProductionLine = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()

  return useMutation<
    ProductionLine,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.createProductionLine>[0]
  >({
    mutationFn: mutations.createProductionLine,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSuccess: (response) => {
      invalidateSettingsQuery('upmStructure')
      return response
    }
  })
}
